import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReporteAprobacionService {

  constructor(private _http: HttpClient) { }

  requestServiciosAprobar(id: number){
    const url  = environment.URL_BASE + "servicioAuthorization/getServiciosPorAprobar?idCliente=" + id;
    return this._http.get(url);
  }

  requestAprobarServicio(id: number){
    const url  = environment.URL_BASE + "servicioAuthorization/getServiciosAprobar?idSupervisor=" + id;
    return this._http.get(url);
  }

  requestRechazarServicio(id:number){
    const url  = environment.URL_BASE + "servicioAuthorization/getServiciosAprobar?idSupervisor=" + id;
    return this._http.get(url);
  }

  requestAprobarCancelarServicio(data: any){
    const url = environment.URL_BASE + "servicioAuthorization/AprobarCancelarServicio"
    return this._http.post(url,data);
  }

  requestConsultarServicio(id: number){
    const url= environment.URL_BASE+"servicioAuthorization/ValidarAprobacion?idServicio="+id ;
    return this._http.get(url)
  }

  requestAprobarCancelarServicioSinAutetication(data: any){
    const url = environment.URL_BASE + "servicio/AprobarCancelarServicio"
    return this._http.post(url,data);
  }

  requestServiciosAprobarSinAutetication(id: number){
    const url  = environment.URL_BASE + "servicio/getServiciosPorAprobar?idCliente=" + id;
    return this._http.get(url);
  }

  requestAprobarServicioSinAutetication(id: number){
    const url  = environment.URL_BASE + "servicio/getServiciosAprobar?idSupervisor=" + id;
    return this._http.get(url);
  }

  requestRechazarServicioSinAutetication(id:number){
    const url  = environment.URL_BASE + "servicio/getServiciosAprobar?idSupervisor=" + id;
    return this._http.get(url);
  }

  requestConsultarServicioSinAutetication(id: number){
    const url= environment.URL_BASE+"servicio/ValidarAprobacion?idServicio="+id ;
    return this._http.get(url)
  }
  
}
